<template>
  <div class="mit-manage-keys-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage Keys</v-card-title>
            <v-card-subtitle class="caption">Managing the list of keys</v-card-subtitle>
            <v-divider></v-divider>
            <MitKeysList></MitKeysList>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import {MitEventBus} from '../../main.js';
  import MitKeysList from '../../components/MitKeysList.vue';

  export default {
    name: 'MitManageKeysPage',
    components: {
      MitKeysList
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
